import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { map, Observable } from 'rxjs';
import { Vendor } from '../../../core/models/entities/vendor';
import { selectUiState } from '../../../core/store/reducers';

@Component({
  selector: 'app-vendor-privacy-policy-page',
  template: `
    <div class="container py-6">
      @if (vendor$ | async; as vendor) {
        <div class="mt-10">
          <div class="text-4xl font-bold">{{
            'vendor-privacy.title' | transloco
          }}</div>
          <div class="font-sembibold mt-4 text-xl uppercase">{{
            vendor.name
          }}</div>
          <p
            class="mt-10"
            [innerHTML]="
              'vendor-privacy.intro' | transloco: { name: vendor.name }
            "
          ></p>
          <div class="mt-8">
            <a routerLink="/politique-confidentialite" target="_blank">
              <app-button variant="primary">{{
                'vendor-privacy.button' | transloco
              }}</app-button>
            </a>
          </div>
        </div>
      } @else {
        <app-loader [centered]="true"></app-loader>
      }
    </div>
  `,
  styles: [],
  standalone: false,
})
export class VendorPrivacyPolicyPageComponent implements OnInit {
  vendor$: Observable<Vendor> = this.store
    .select(selectUiState)
    .pipe(map((uiState) => uiState.vendor));

  constructor(private store: Store) {}

  ngOnInit(): void {}
}
